import { render, staticRenderFns } from "./walletRecord.vue?vue&type=template&id=db538492&scoped=true&"
import script from "./walletRecord.vue?vue&type=script&lang=js&"
export * from "./walletRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db538492",
  null
  
)

export default component.exports